// Default settings for toastr
toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: true,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    onclick: null,
    showDuration: 300,
    hideDuration: 1000,
    timeOut: 5000,
    extendedTimeOut: 1000,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut"
};

const success = (message) => {
    toastr['success'](message);
}

const info = (message) => {
    toastr['info'](message);
}

const warning = (message) => {
    toastr['warning'](message);
}

const error = (message, dontTimeout = false) => {
    if (dontTimeout) {
        toastr.options.closeButton = true;
        toastr.options.timeOut = 0;
        toastr.options.extendedTimeOut = 0;
    }

    toastr['error'](message);

    if (dontTimeout) {
        toastr.options.closeButton = false;
        toastr.options.timeOut = 5000;
        toastr.options.extendedTimeOut = 1000;
    }
}

export default {
    success,
    info,
    warning,
    error
}
